import React, { Component } from "react";
import "../../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ViewTopBar from "../common_components/viewChanger";
import BottomBar from "../common_components/bottom_bar.component";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import PrivacyPolicy from "./privacyPolicy.js";
import TermsOfService from "./termsOfService";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    "@media (min-width:200px)": {
      marginTop: -15,
    },
    "@media (min-width:600px)": {
      marginTop: -15,
    },
    "@media only screen and (max-width: 960px) and (min-width:601px)": {
      height: 700,
      width: "auto",
      marginTop: -10,
    },
    "@media only screen and (max-width: 1260px) and (min-width: 960px)": {
      height: 750,
      width: "auto",
      marginTop: -10,
    },
    "@media only screen and (max-width: 1960px) and (min-width: 1260px)": {
      height: "auto",
      marginTop: -10,
    },
  },
  text_title: {
    fontSize: "3rem",
    textAlign: "center",
    fontFamily: "Open Sans",
    fontWeight: "300",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  text: {
    color: "black",
    fontFamily: "Open Sans",
    fontWeight: "300",
    margin: 80,
    textAlign: "left",
    fontSize: "1.25rem",
    "@media (min-width:200px)": {
      fontSize: "0.75rem",
    },
    "@media (min-width:600px)": {
      fontSize: "0.8rem",
    },
    "@media (min-width:960px)": {
      fontSize: "1rem",
    },
  },
  button_text: {
    fontFamily: "Open Sans",
    // marginTop: -7,
    "@media (min-width:200px)": {
      fontSize: "0.75rem",
      // marginTop: -4,
    },
    "@media (min-width:600px)": {
      fontSize: "0.8rem",
      // marginTop: -5,
    },
    "@media (min-width:960px)": {
      fontSize: "1rem",
      // marginTop: -7,
    },
  },
});

class PrivacyTerms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.location.state
        ? JSON.parse(JSON.stringify(this.props.location.state.prevPath))
        : "Privacy Policy | CanaWho",
    };
  }

  componentWillMount() {
    document.title = this.state.selected;
  }

  componentDidUpdate() {
    document.title = `${this.state.selected}`;
  }

  handleChange(index) {
    if (index === 0) {
      this.setState({ selected: "Privacy Policy | CanaWho" });
    } else if (index === 1) {
      this.setState({ selected: "Terms of Service | CanaWho" });
    }
  }

  render() {
    const { classes } = this.props;
    const { selected } = this.state;
    return (
      <div className={classes.root}>
        <ViewTopBar />
        <Grid container alignItems="center" justify="center">
          <Grid container alignItems="center" justify="center">
            <Grid item xs={12}>
              <h1 class={classes.text_title}>
                <u>CanaWho's Legal Information</u>
              </h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="secondary" size="medium">
                <Button
                  style={{
                    color:
                      selected === "Privacy Policy | CanaWho"
                        ? "white"
                        : "black",
                    background:
                      selected === "Privacy Policy | CanaWho"
                        ? "#F6277F"
                        : null,
                    textTransform: "none",
                  }}
                  onClick={() => this.handleChange(0)}
                >
                  <span class={classes.button_text}>Privacy Policy</span>
                </Button>
                <Button
                  style={{
                    color:
                      selected === "Privacy Policy | CanaWho"
                        ? "black"
                        : "white",
                    background:
                      selected === "Privacy Policy | CanaWho"
                        ? null
                        : "#F6277F",
                    textTransform: "none",
                  }}
                  onClick={() => this.handleChange(1)}
                >
                  <span class={classes.button_text}>Terms of Service</span>
                </Button>
              </ButtonGroup>
            </Grid>
            <Typography variant="h5" class={classes.text}>
              {selected === "Privacy Policy | CanaWho" ? (
                <PrivacyPolicy />
              ) : (
                <TermsOfService />
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid style={{ width: "100%" }}>
          <BottomBar />
        </Grid>
      </div>
    );
  }
}

PrivacyTerms.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PrivacyTerms);
